import React from "react";
import TokenContainer from "../Token/TokenContainer";
import TokenTabs from "../Token/TokenTabs";
import TokenDetails from "../TokenHeader/TokenDetails";
import TokenHeader from "../TokenHeader/TokenHeader";
import NFTDetails from "./NFTDetails";
import NftTabs from "./NFTTabs/NftTabs";

const NFT = ({ NftType }) => {
  return (
    <TokenContainer>
      <TokenHeader brand={NftType ? '/img/company-icon.png' : "/img/nft-name.png"}>
        {NftType ? <NFTDetails /> : <TokenDetails />}
      </TokenHeader>

      {NftType ? <TokenTabs /> : <NftTabs />}
    </TokenContainer>
  );
};

export default NFT;
